var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95964 10.7071C5.56912 10.3166 5.56912 9.68343 5.95964 9.2929L12.6263 2.62624C13.0168 2.23571 13.65 2.23571 14.0405 2.62624C14.431 3.01676 14.431 3.64993 14.0405 4.04045L8.08096 10L14.0405 15.9596C14.431 16.3501 14.431 16.9833 14.0405 17.3738C13.65 17.7643 13.0168 17.7643 12.6263 17.3738L5.95964 10.7071Z",
    fill: "#1D8DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlue);
export default __webpack_public_path__ + "static/media/arrowBack-blue.97e7d81afc10f99764a1e35a3ca364ef.svg";
export { ForwardRef as ReactComponent };